// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__kI6wU","overflowing":"ReadFullNote_overflowing__3KmZE"};